import PlusLogoDark from "@/assets/icons/plus-logo-dark.svg";
import PlusLogoLight from "@/assets/icons/plus-logo-light.svg";
import { useContextBarAppearance } from "@/contexts/ContextBarAppearanceContext";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader } from "../ui/card";
import { ScrollArea } from "../ui/scroll-area";

type MailSummaryProps = {
    content: string;
};

const MailSummary = ({ content }: MailSummaryProps) => {
    const { t } = useTranslation();
    const { isDeepFocus } = useContextBarAppearance();
    const defaultCardClass = "bg-surface-recap";
    const deepFocusCardClass = "bg-white/5 border border-white/10";

    return (
        <Card className={isDeepFocus ? deepFocusCardClass : defaultCardClass}>
            <CardHeader variant="mailInfos">
                <p className={cn(isDeepFocus && "text-white")}>
                    {t("email.loopSummary")}
                </p>
                <img
                    alt=""
                    className="h-4"
                    src={isDeepFocus ? PlusLogoDark : PlusLogoLight}
                />{" "}
            </CardHeader>
            <CardContent variant="mailInfos">
                <ScrollArea viewportClassName="max-h-30">
                    <p className={cn(isDeepFocus && "text-white")}>{content}</p>
                </ScrollArea>
            </CardContent>
        </Card>
    );
};

export default MailSummary;
